var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrap"},[_c('div',{staticClass:"error-content"},[_c('div',{staticClass:"error-title"},[_vm._v(" "+_vm._s(_vm.$g("const.confirm.noPermission"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }